import React from 'react';

/**
 * Custom dot renderer for defect points
 * Renders a red triangle with an exclamation mark
 * Clickable to open defect details in a new tab
 */
const DefectDot = (props) => {
  const { cx, cy, className, payload } = props;
  const size = 12; // Triangle size
  
  const handleClick = (e) => {
    e.stopPropagation();
    
    // Check if we have defects data
    if (payload?.defects?.length > 0) {
      // Get the first defect ID - if there are multiple, we'll open the first one
      const defectId = payload.defects[0]?.id;
      
      if (defectId) {
        // Open defect details in a new tab
        window.open(`/app/defects/${defectId}`, '_blank');
      }
    }
  };
  
  return (
    <g 
      className={className} 
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      {/* Red triangle */}
      <path 
        d={`M${cx},${cy-size} L${cx+size},${cy+size*0.7} L${cx-size},${cy+size*0.7} Z`} 
        fill="#FF3A33"
        stroke="#CC0000"
        strokeWidth={1}
      />
      {/* White exclamation mark */}
      <text
        x={cx}
        y={cy + size*0.3}
        textAnchor="middle"
        fill="#FFFFFF"
        fontSize={size*1.2}
        fontWeight="bold"
        dominantBaseline="middle"
      >
        !
      </text>
    </g>
  );
};

export default DefectDot; 